<section class="card">
  <!-- Header -->
  <div class="card-header">
    <h3 class="card-title">
      {{ 'achievements.achievements' | translate }}
    </h3>
  </div>

  <!-- Body -->
  <div class="card-body pt-0">
    <achievement-table
      class="d-block card-table"
      [tableData]="(achievementSurveyAnswers$ | async) || []"
      [participantMemberIds]="(participantMemberIds$ | async) || []"
      [questionIds]="(achievementQuestionIds$ | async) || []"
      [bulkActions]="[BulkAction.SET_ACHIEVEMENTS, BulkAction.SET_ALL_TO_ACHIEVED]"
      (onOpenAdjust)="onOpenAdjust($event)"
      (onBulkAction)="onBulkAction($event)"
    ></achievement-table>
  </div>
</section>
